<tam-dialog class="email-digest-confirm-container" tid="send_email_digest_dialog" [opened]="dialogOpened"
    (keydown.esc)="clickCancel()">
    <ng-template #title>
        <span class="dialog-title">{{'emailDigest.confirm_your_operation' | stringLiterals}}</span>
        <smart-icon class="dark dialog-close" name="close" (click)="clickCancel()">
        </smart-icon>
    </ng-template>
    <ng-template #body>
        <span class="recipients">{{'emailDigest.recipients' | stringLiterals}}</span>
        <div class="recipient-list">

            <div class="recipient-list-header recipient-list-bac">
                <label class="recipient-type">{{'emailDigest.name' | stringLiterals}}</label>
                <div class="border-line"></div>
                <label class="recipient-email">{{'emailDigest.email_address' | stringLiterals}}</label>
            </div>
            <div class="recipient-info">
                <div kendoTooltip class="recipient-list-header recipient-list-content"
                    *ngFor="let item of recipientList;let i = index;" (click)="onClickCheckItem(item)">
                    <label class="recipient-type" title="{{item.name}}">{{item.name}}</label>
                    <div class="recipient-email">
                        <label class="email" title="{{item.primaryEmail}}">{{item.primaryEmail}}</label>
                        <label class="delete">
                            <smart-icon *ngIf="!(emailDigest.recipients.includes(item.id))" name="close"
                                class="hover-color" (click)="clickDelete(item)"></smart-icon>
                        </label>
                    </div>
                </div>
            </div>
        </div>
        <div class="tam-form-link">
            <span #addAnchor (click)="clickAddRecipient()">{{'emailDigest.add_additional_recipient' |
                stringLiterals}}</span>
        </div>
        <div class="addtional-recipient" role='searchBox'>
            <kendo-popup [anchor]="addAnchor" class="add-popup" *ngIf="isAddShow">
                <div class="search-box-user">
                    <aacl-keyword-search [options]="keywordSearchOptionsUser">
                    </aacl-keyword-search>
                </div>
                <div class="item-container">
                    <div class="item" *ngFor="let user of (userList | recipientListFilter: keywordUser)"
                        (click)="onUserClick(user)" kendoTooltip>
                        <!-- <label class="user-name"> {{user.name}}</label>
                        <label class="user-email" *ngIf="user['secure-email']">{{user['secure-email']}}</label> -->
                        <label class="user-name" title=" {{user.name}}"
                            [style.font-weight]="user.type === 'team' ? 'bold' : 'normal'">{{user.name}}</label>
                        <label class="user-email" title="{{user.primaryEmail}}"
                            [style.font-weight]="user.type === 'team' ? 'bold' : 'normal'">{{user.primaryEmail}}</label>

                    </div>
                </div>
            </kendo-popup>
        </div>

    </ng-template>
    <ng-template #footer>
        <button class="footer-button cancel-button" tam-button [tamType]="'tertiary'" [tamSize]="'normal'"
            (click)="clickCancel()">{{'emailDigest.cancel' | stringLiterals}}</button>
        <button class="footer-button send-button" tam-button [tamType]="'primary'" [tamSize]="'normal'"
            [tamLoading]="isSaving" [disabled]="isSaving" (click)="clickSaveEmailDigest()">{{'emailDigest.send' |
            stringLiterals}}</button>
    </ng-template>
</tam-dialog>